import { attr, classNames, css, customElement, GenesisElement, html } from '@genesislcap/web-core';

@customElement({
  template: html<GreyButton>`
    <rapid-button class="${(x) => classNames(['active', x.active])}"><slot></slot></rapid-button>
  `,
  name: 'grey-button',
  styles: css`
    rapid-button {
        height: fit-content;
    }

    rapid-button::part(control) {
      border-color: #fff;
      padding: 8px 0;
      font-size: 12px;
      line-height: 1.2;
    }

    rapid-button.active::part(control) {
      background: rgba(135, 155, 166, 0.7);
    }
  `,
})
export class GreyButton extends GenesisElement {
  @attr({ mode: 'boolean' }) active;
}
